import React, { useMemo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

// Define expected data structure for this node
interface EventSwitchNodeData {
  label?: string;
  config?: { [eventName: string]: any }; // Expects an object where keys are event names
}

const EventSwitchNode: React.FC<NodeProps<EventSwitchNodeData>> = ({ data }) => {
  const label = data?.label || 'Event Specific';

  // Get event names from the config object keys
  const eventNames = useMemo(() => {
    return data?.config ? Object.keys(data.config) : [];
  }, [data?.config]);

  // Calculate handle positions dynamically
  const handleGap = 30; // Vertical gap between handles
  const totalHeight = (eventNames.length + 1) * handleGap; // +1 for the default/global output

  return (
    <div className="playbook-node event-type-node" style={{ minHeight: totalHeight, width: 200 }}>
      {/* Input handle from PlaybookRoot */}
      <Handle
        type="target"
        position={Position.Top}
        id="input"
        style={{ background: '#555' }}
      />
      <div className="playbook-node-header">
        <strong>{label}</strong>
      </div>
      <div style={{ padding: '5px 0', fontSize: '0.9em', color: '#555' }}>
        (Switch based on event name)
      </div>

      {/* Output handle for global/default logic (if any) */}
      {/* Consider adding a specific handle if global logic needs separate connection */}
      {/* <Handle
        type="source"
        position={Position.Right}
        id="global-output"
        style={{ top: handleGap / 2, background: '#aaa' }}
      />
      <div style={{ position: 'absolute', right: -60, top: handleGap / 2 - 7, fontSize: '0.8em', color: '#777' }}>
        Global
      </div> */}

      {/* Dynamically create output handles for each event name */}
      {eventNames.map((eventName, index) => {
        const handleId = `event-${eventName}-output`;
        const topPosition = (index + 1) * handleGap; // Start below the header/global handle

        return (
          <React.Fragment key={handleId}>
            <Handle
              type="source"
              position={Position.Right}
              id={handleId}
              style={{ top: topPosition, background: '#555' }}
            />
            {/* Add label next to the handle */}
            <div style={{ position: 'absolute', right: -60, top: topPosition - 7, fontSize: '0.8em', color: '#333' }}>
              {eventName}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default EventSwitchNode;
